<template>
    <div id="ruler" ref="ruler" :style="rulerStyle" v-show="show">
        <object id="ruler30" v-show="showRuler30" ref="ruler30"></object>
        <div id="ruler100" v-show="!showRuler30" ref="ruler100">
            <div id="ruler100-content">
                <object id="" ref="ruler100_1"></object>
                <object id="" ref="ruler100_2"></object>
                <object id="" ref="ruler100_3"></object>
                <object id="" ref="ruler100_4"></object>
            </div>
        </div>
        <div class="drag-area" :style="hitAreaStyle" ref="dragArea" @pointerdown="startDrag($event, $refs.dragArea, null, toolScale)">
            <div ref="center" class="center"></div>
        </div>
        <div id="switch-ruler" :style="{ left: positions.switchRuler.x, top: positions.switchRuler.y }"
            @click="handleSwitchRuler"></div>
        <div class="control-button rotate-button" @pointerdown="startRotate">
            <object ref="rotateButton"></object>
        </div>
        <div class="control-button rotate-ninety-button" @pointerdown="handleRotateNinety">
            <object ref="rotateNinetyButton"></object>
        </div>
        <div class="control-button close-button" @pointerdown="switchRuler(false)">
            <object ref="closeButton"></object>
        </div>
        <div class="control-button scale-button" @pointerdown="startScale">
            <object ref="scaleButton"></object>
        </div>
    </div>
</template>

<script>
import ruler30 from '../../assets/art/math_tool/ruler30.svg';
import ruler100_1 from '../../assets/art/math_tool/0-25_ruler100.svg';
import ruler100_2 from '../../assets/art/math_tool/26-50_ruler100.svg';
import ruler100_3 from '../../assets/art/math_tool/51-75_ruler100.svg';
import ruler100_4 from '../../assets/art/math_tool/76-100_ruler100.svg';
import DragElem from '../DragElem.vue';

import deleteIcon from '../../assets/control/delete_icon.svg'
import scaleIcon from '../../assets/control/scale_icon.svg'
import touchRotateIcon from '../../assets/control/touch_rotate_icon.svg'
import rotateNinetyIcon from '../../assets/control/rotate_ninety_icon.svg'
import { store } from '../../store';
import { EVENT_TYPE } from '../../js/event/event';
import { focusStore } from '@/js/store/nowFocusStore';

export default {
    name: "ruler",
    data() {
        return {
            show: false,
            showRuler30: false,

            left: 726,
            top: 508,
            limit: false,
            rotation: 0,
            scale: 0.5,
            preScale: 0.5,
            deltaAngle: 0,

            positions: {
                switchRuler: {
                    x: "calc(100% - 10px)",
                    y: "50%"
                },
                ruler: {
                    x: 0,
                    y: 0
                }
            },

            pointerType: "",

            ruler100Height: 136
        }
    },
    mixins: [
        DragElem
    ],
    props: {
        toolScale: Number
    },
    mounted() {
        this.$refs.ruler30.data = ruler30;

        this.$refs.ruler100_1.data = ruler100_1;
        this.$refs.ruler100_2.data = ruler100_2;
        this.$refs.ruler100_3.data = ruler100_3;
        this.$refs.ruler100_4.data = ruler100_4;

        this.$refs.rotateButton.data = touchRotateIcon;
        this.$refs.rotateNinetyButton.data = rotateNinetyIcon;
        this.$refs.closeButton.data = deleteIcon;
        this.$refs.scaleButton.data = scaleIcon;

        setTimeout(() => {
            this.$refs.ruler100.style.width = "1300px";
            this.$refs.ruler100.style.height = this.ruler100Height + "px";
        }, 1000);
    },
    methods: {
        switchRuler(show) {
            const containerPosition = focusStore.mainBookPage.containerPosition;
            const canvasWidth = focusStore.mainBookPage.canvasWidth;
            const canvasHeight = focusStore.mainBookPage.canvasHeight;
            const containerScale = focusStore.mainBookPage.containerScale;

            this.show = show;

            if(this.show) {
                this.left = (-containerPosition.x + canvasWidth / 2) / containerScale;
                this.top = (-containerPosition.y + canvasHeight / 2) / containerScale;
            }
        },
        handleSwitchRuler() {
            this.showRuler30 = !this.showRuler30;

            this.positions.switchRuler.x = "calc(100% - 10px)";
            if (!this.showRuler30) {
                setTimeout(() => {
                    this.$refs.ruler100.style.height = this.ruler100Height + "px";
                }, 10);
            }
        },
        //#region rotate
        /**
         * 
         * @param {PointerEvent} e 
         */
        startRotate(e) {
            this.pointerType = e.pointerType;
            const rulerRect = this.$refs.center.getBoundingClientRect();
            console.log("rect::", rulerRect);
            this.positions.ruler.x = rulerRect.x;
            this.positions.ruler.y = rulerRect.y;

            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.rotate);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endRotate);
        },
        /**
         * 
         * @param {Event} e 
         */
        rotate(e) {
            let pointer = {};
            if (e.type == "pointermove" || e.type == "mousemove") {
                pointer.x = e.clientX;
                pointer.y = e.clientY;
            } else {
                pointer.x = e.touches[0].screenX;
                pointer.y = e.touches[0].screenY;
            }

            const x = pointer.x / store.contentScale;
            const y = pointer.y / store.contentScale;

            //計算斜率
            let slope = (y - this.positions.ruler.y) / (x - this.positions.ruler.x);
            let angle = (Math.atan(slope) / (Math.PI / 180)) - 180;


            if (x < this.positions.ruler.x) {
                angle += 180;
            }

            this.rotation = angle;
        },
        endRotate() {
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.rotate);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endRotate);
        },
        //#endregion
        //#region  rotate ninety
        handleRotateNinety() {
            if (this.rotation % 90 == 0) {
                this.rotation += 90;
            } else {
                this.rotation = (Math.floor(this.rotation / 90) + 1) * 90;
            }
        },
        //#endregion
        //#region scale
        /**
         * 
         * @param {PointerEvent} e 
         */
        startScale(e) {
            this.preScale = this.scale;

            const rulerRect = this.$refs.center.getBoundingClientRect();
            this.positions.ruler.x = rulerRect.x;
            this.positions.ruler.y = rulerRect.y;

            const distanceX = (e.clientX / store.contentScale - this.positions.ruler.x);
            const distanceY = (e.clientY / store.contentScale - this.positions.ruler.y);
            this.distanceScale = distanceX * distanceX + distanceY * distanceY;

            this.pointerType = e.pointerType;

            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.scaling);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endScale);
        },
        /**
         * 
         * @param {Event} e 
         */
        scaling(e) {
            let pointer = {};
            if (e.type == "pointermove" || e.type == "mousemove") {
                pointer.x = e.clientX / store.contentScale;
                pointer.y = e.clientY / store.contentScale;
            } else {
                pointer.x = e.touches[0].screenX / store.contentScale;
                pointer.y = e.touches[0].screenY / store.contentScale;
            }

            const distanceX = (pointer.x - this.positions.ruler.x);
            const distanceY = (pointer.y - this.positions.ruler.y);

            const deltaDistance = (distanceX * distanceX + distanceY * distanceY) - this.distanceScale;

            this.scale = this.preScale + (deltaDistance / this.distanceScale / 5);
        },
        endScale() {
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.scaling);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endScale);
        }

        //#endregion
    },
    computed: {
        hitAreaStyle() {
            return {
                "width": this.showRuler30 ? "2520px" : "1300px",
            }
        },
        rulerStyle() {
            return {
                "top": this.top + 'px',
                "left": this.left + 'px',
                "transform": `scale(${this.scale}) rotate(${this.rotation}deg) translate(-50%, -50%)`
            }
        }
    }
}

</script>

<style scoped>
#ruler {
    z-index: 9999;
    position: absolute;
    transform: scale(0.5) rotate(0turn);
    transform-origin: left top;
}

#ruler30 {
    pointer-events: none;
}

#ruler100-content {
    display: flex;
    pointer-events: none;
}

#ruler100 {
    display: flex;
    overflow: hidden;
    overflow-x: scroll;
}

#ruler100::-webkit-scrollbar {
    width: 20px;
}

#ruler100::-webkit-scrollbar-track {
    background: #ffffff;
}

#ruler100::-webkit-scrollbar-thumb {
    background: #00af4f;
}

#switch-ruler {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: fixed;
    background: #ffbf00;
}

.drag-area {
    position: fixed;
    height: 114px;
    top: 0px;
}

.control-button {
    position: fixed;
    width: 50px;
    height: 50px;
}

.control-button object {
    width: 50px;
    height: 50px;
    pointer-events: none;
}

.rotate-button {
    top: 0px;
    left: -50px;
}

.rotate-ninety-button {
    top: 60px;
    left: -50px;
}

.close-button {
    top: 0px;
    left: -110px;
}

.scale-button {
    top: 60px;
    left: -110px;
}
.center {
    left: 650px;
    top: 57px;
    width: 0px;
    height: 0px;
    position: relative;
}
</style>